'use client'

import dynamic from 'next/dynamic'
import { APITypes, PlyrProps } from 'plyr-react'
import { forwardRef, Suspense } from 'react'

const Plyr = dynamic(() => import('./PlyrLazy'), {
  ssr: false
})

type PlyrClientProps = PlyrProps & {
  className?: string
}

const PlyrClient = forwardRef<APITypes, PlyrClientProps>((props, ref) => (
  <Suspense>
    <Plyr ref={ref} {...props} />
  </Suspense>
))

PlyrClient.displayName = 'PlyrClient'

export type { APITypes }
export default PlyrClient
